module.exports = __webpack_public_path__ + "static/media/sdg_icon_2.8286a886.png";